import { useEffect } from "react";

export default function AccessibilityStatement() {
  useEffect(() => { document.title = "הצהרת נגישות | topiqz"; }, []);
  return (
    <main id="main-content" className="privacy-page" dir="rtl">
      <nav aria-label="חזרה לדף הבית" className="privacy-back-nav">
        <a href="/">← חזרה לדף הראשי</a>
      </nav>
      <div className="privacy-content">
        <h1>הצהרת נגישות</h1>

        <h2>1. מחויבות לנגישות</h2>
        <p>
          אנו מחויבים להנגשת האפליקציה לכלל המשתמשים, לרבות אנשים עם
          מוגבלויות, בהתאם לחוק שוויון זכויות לאנשים עם מוגבלות,
          התשנ&rdquo;ח-1998, ותקנות נגישות השירות (התאמות נגישות לשירות),
          התשע&rdquo;ג-2013.
        </p>

        <h2>2. תקן נגישות</h2>
        <p>
          האפליקציה שואפת לעמוד בדרישות{" "}
          <strong>תקן ישראלי 5568</strong>, המבוסס על הנחיות{" "}
          <strong>WCAG 2.1 ברמה AA</strong> (Web Content Accessibility
          Guidelines).
        </p>

        <h2>3. מה עשינו</h2>
        <p>במסגרת התאמות הנגישות שלנו:</p>
        <ul>
          <li>כל דפי האפליקציה מוגדרים בשפה העברית וכיוון RTL.</li>
          <li>ניתן לנווט באפליקציה באמצעות מקלדת בלבד.</li>
          <li>כפתורים ואלמנטים אינטראקטיביים כוללים תוויות נגישות (aria-label).</li>
          <li>שדות טפסים מקושרים לתוויות (labels).</li>
          <li>הודעות שגיאה ומצב מוכרזות אוטומטית לקוראי מסך (aria-live).</li>
          <li>ניתן לדלג ישירות לתוכן הראשי (skip link).</li>
          <li>כותרות דפים מתעדכנות בהתאם לעמוד הנוכחי.</li>
          <li>תמיכה במצב מופחת תנועה (prefers-reduced-motion).</li>
          <li>מחווני פוקוס (focus indicators) ברורים על כל אלמנט אינטראקטיבי.</li>
          <li>שאלות הבחירה ניתנות למענה גם בלחיצה וגם בדיבור.</li>
        </ul>

        <h2>4. מגבלות ידועות</h2>
        <p>
          אנו ממשיכים לפעול לשיפור הנגישות. מגבלות ידועות בשלב זה:
        </p>
        <ul>
          <li>
            חלק מחוויית הלימוד מבוססת על שיחה קולית עם מורה AI. משתמשים
            שאינם יכולים להשתמש בדיבור יכולים לבחור תשובות בלחיצה, אך חלק
            מהאינטראקציה הקולית אינה זמינה בצורה חלופית.
          </li>
          <li>
            ניגודיות הצבעים נבדקת באופן שוטף, אך שילובי צבע מסוימים בערכות
            נושא אישיות עשויים שלא לעמוד ביחס 4.5:1 בכל המקרים.
          </li>
        </ul>

        <h2>5. יצירת קשר בנושא נגישות</h2>
        <p>
          נתקלתם בבעיית נגישות? נשמח לשמוע ולתקן. ניתן לפנות אלינו במייל:{" "}
          <a href="mailto:perestom@gmail.com">perestom@gmail.com</a>
        </p>
        <p>
          אנו מתחייבים לטפל בפניות נגישות בתוך 14 ימי עסקים.
        </p>

        <p className="privacy-updated">עודכן לאחרונה: אפריל 2026</p>
      </div>
    </main>
  );
}
